import "../../css/Post2.css";
import Footer from "../../Footer";

function Post9() {
  return (
    <div className="post-page">
      {/* 🔹 Hero Section */}
      <section className="post-hero">
        <div className="post-hero-content">
          <h1>News Recap Archives</h1>
          <p className="subtitle">Want to know what has happened recently in the world?</p>
          <p className="tagline">Read below for quick summaries covering the past weeks.</p>
        </div>
      </section>

        {/* 🔹 Main Content - RECENT */}
                <article className="post-content">



    {/* 🔹 Embedded YouTube Video */}
      <div className="learning-log-video">
        <iframe
          width="100%"
          height="480"
          src="https://www.youtube.com/embed/d2yWmA4bcBE?autoplay=1&mute=1&playsinline=1"
          title="News Weekly Recap"
          frameBorder="0"
          allow="autoplay; encrypted-media"
          allowFullScreen
        ></iframe>
      </div>

      {/* 🔹 Blog Content */}

        <div className="highlight-box">
          <h3>Week of 1/26/26: </h3>
          <ul>
            <li>
              <strong>- </strong>Past few days of news in 1 minute. Articles mentioned / shown include:
            </li>
            <li>
              <strong>- </strong>1. USA Today: “Winter Storm Path.”
2. NY Times: “Demonstrators Flood Minneapolis Streets as Hundreds of Businesses Close to Protest ICE.”
3. ABC News: “Minneapolis ICE shooting live updates: Man Killed In Shooting Involves Federal Agents.”
4. AP News Minnesota Updates.
5. US NEWS: “US To Gain Sovereignty Over American Bases in Greenland.”
6. AI Summary of European Leader Statement on Greenland (fact checked against the material source).
7. ABC News: “Europe ‘united’ in face of Trump Greenland threats, tariffs, EU Chief Says.”
8. AI Recap of Netflix subscribers and Q4 earnings (checked against Q4 source).
9. Informed.now on Netflix Uodate
10. NCAA: “Indiana Defeats Miami to Win the College Football Championship.”
            </li>
            <li>
              <strong>- </strong>Although there are some funny faces involved in this weekly news recap, what is going on with ICE in Minnesota is serious. Please check out articles related to Alex Pretti and what’s going on. 
            </li>
            <li>
              <strong>- </strong> Please take care of yourself and others.
            </li>
          </ul>
        </div>

      </article>

    <article className="post-content">

        {/* 🔹 Embedded YouTube Video */}
      <div className="learning-log-video">
        <iframe
          width="100%"
          height="480"
          src="https://www.youtube.com/embed/3NgtVP3fInU?autoplay=1&mute=1&playsinline=1"
          title="News Weekly Recap"
          frameBorder="0"
          allow="autoplay; encrypted-media"
          allowFullScreen
        ></iframe>
      </div>

      {/* 🔹 Blog Content */}

        <div className="highlight-box">
          <h3>Week of 1/12/26: </h3>
          <ul>
            <li>
              <strong>1. </strong>Iran protests: There have been protests for several weeks. CNN reports "Anti-government protests have erupted across all 31 of Iran’s provinces." The Iranian government has cracked down hard as hundreds have been killed and thousands arrested. US President Donald Trump has threatened to attack Iran.
            </li>
            <li>
              <strong>2. </strong>ICE in Minneapolis: Many more homeland security agents are getting moved into Minnesota. This comes after an ICE officer shot and killed Renee Good which now has an open investigation. 
            </li>
            <li>
              <strong>3. </strong>Federal Reserve Subpoena: A subpoena is a formal court order compelling someone to provide testimony or produce evidence (documents, records) for a legal proceeding. This is over the multi-billion dollar Federal Reserve building makeover. According to NPR, 
              "The Justice Department has subpoenaed the Federal Reserve for information on the central bank's headquarters renovation." Trump wants lower interest rates and there is speculation that this is part of the administration's pressure campaign to force the central bank to make bigger cuts in interest rates.
            </li>
            <li>
              <strong>4. </strong> Golden Globes: The Golden Globes are an annual awards ceremony that honor the best in film and American television productions. Hamnet won the Golden Globe for Best Picture, Drama. Actors like Timothée Chalamet and Teyana Taylor were honored. The Golden Globes also included a new category, best podcast.
            </li>
            <li>
              <strong>5. </strong> Sources: 
(1) https://www.nytimes.com/2026/01/12/us/politics/fbi-renee-good-ice-shooting.html, 
(2) https://www.cbsnews.com/minnesota/video/after-fbi-rejection-county-attorney-moves-forward-with-renee-good-investigation/
(3) https://www.cnn.com/2026/01/12/middleeast/iran-mass-protests-explained-intl,
(4) https://www.npr.org/2026/01/11/nx-s1-5674034/fed-powell-subpoena-doj-building-renovation,
(5) https://www.yahoo.com/entertainment/celebrity/live/2026-golden-globes-live-updates-full-list-of-winners-as-one-battle-after-another-and-hamnet-take-home-top-film-nods-adolescence-recognized-for-tv-with-4-wins-000306961.html

            </li>
          </ul>
        </div>

      </article>

    <article className="post-content">

    {/* 🔹 Embedded YouTube Video */}
      <div className="learning-log-video">
        <iframe
          width="100%"
          height="480"
          src="https://www.youtube.com/embed/5g8bPzI7ATk?autoplay=1&mute=1&playsinline=1"
          title="News Weekly Recap"
          frameBorder="0"
          allow="autoplay; encrypted-media"
          allowFullScreen
        ></iframe>
      </div>

      {/* 🔹 Blog Content */}

        <div className="highlight-box">
          <h3>Week of 12/31/25: </h3>
          <ul>
            <li>
              <strong>1. </strong>Trump and Zelensky meet to discuss Peace Deal - The presidents met to discuss a possible Peace Deal and both walked away stating that they might be close to a deal that would end a nearly four year war between Russia and Ukraine.
            </li>
            <li>
              <strong>2. </strong>US Strikes ISIS in Nigeria. The US Africa Command announced that strikes in the Sokoto State killed multiple ISIS terrorists.
            </li>
            <li>
              <strong>3. </strong>Let's talk cars - General Motors is on pace to be the top U.S.-traded automaker stock of 2025 - This validates the company’s reemergence from bankruptcy in 2009.
            </li>
            <li>
              <strong>4. </strong> Conservative presidential candidate wins contested election in Honduras amid pushback. He won by less than 1% of the vote and the loser refused to concede.
            </li>
            <li>
              <strong>5. </strong> If you're a Nugget's fan you got a nice Christmas surprise because Nikola Jokic had a historic 56-point triple-double on Christmas. However, he is now out with an injury (as of 12/31/25).
              In the WNBA, there is ongoing negotiations for a collective bargaining agreement. 
              The player's union (WNBPA) has authorized players to call a strike if necessary. Players are wanting a larger share of the league's rapidly growing revenue.
            </li>
          </ul>
        </div>

      </article>

    <article className="post-content">

    {/* 🔹 Embedded YouTube Video Last Week */}
      <div className="learning-log-video">
        <iframe
          width="100%"
          height="480"
          src="https://www.youtube.com/embed/o7XgvG1-xPA?autoplay=1&mute=1&playsinline=1"
          title="News Weekly Recap"
          frameBorder="0"
          allow="autoplay; encrypted-media"
          allowFullScreen
        ></iframe>
      </div>

      {/* 🔹 Blog Content */}

        <div className="highlight-box">
          <h3>Week of 12/23/25: </h3>
          <ul>
            <li>
              <strong>1. </strong>Congress has left for the year without reaching a health care deal. The Affordable Care Act will expire on Dec. 31 which will cause 22 million to lose lower insurance benefits.
            </li>
            <li>
              <strong>2. </strong>There is a push to build more nuclear reactors across the United States and Japan announced an initiative to restart the world's biggest nuclear power plant.
            </li>
            <li>
              <strong>3. </strong>Third, the Trump administration has ruled that starting Jan 2026, those with student debt will be garnished to repay their loans. This means that money or property of a third party (in this case loans), be seized to satisfy a debt owed (in this case the debt is tuition). 
            </li>
            <li>
              <strong>4. </strong> Holiday spending is up for the year of 2025. Even with many uncertain about the state of the current economy, early numbers are coming back to show one of the highest spending years yet. 
            </li>
            <li>
              <strong>5. </strong> Texas A&M won the 2025 Women's Division 1 Volleyball Championship.
            </li>
          </ul>
        </div>

      </article>

      {/* Mailing List CTA */}
      <div className="cta">
        <h2>Stay in the loop ✉️</h2>
        <p>Sign up for my mailing list and never miss an update.</p>
        <a href="/signup" className="cta-button">
          Join the Mailing List
        </a>
      </div>

      <Footer />
    </div>
  );
}

export default Post9;